import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import styles from './index.module.scss';
import { BlockTitle, TenderFile } from 'src/shared';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useTask, useUpdateBidTasks } from 'src/models/bids/BidTask/hooks';
import TextArea from 'antd/lib/input/TextArea';
import { Button, Form } from 'src/common';
import { TASK_EDITOR_ICON_MAPPER } from 'src/models/bids/BidTask/mappers';

const fieldName = 'question';

export const BidTaskContent: FC = () => {
  const { t } = useTranslation();
  const { data: task } = useTask();

  const [form] = Form.useForm();
  const [isFocused, setIsFocused] = useState(false);

  const [updateTasks] = useUpdateBidTasks();

  const onSave = useCallback(() => {
    if (!!task) {
      const content = form.getFieldValue(fieldName);
      updateTasks({
        questions: [task],
        groupId: task.groupId,
        content: content ?? ''
      });
      setIsFocused(false);
    }
  }, [form, task, updateTasks]);

  const onCancel = useCallback(() => {
    form.resetFields([fieldName]);
    setIsFocused(false);
  }, [form]);

  useEffect(
    () =>
      form.setFieldsValue({
        question: task?.content || ''
      }),
    [form, task]
  );

  const initialValues: { question: string } = useMemo(() => {
    return {
      question: task?.content || ''
    };
  }, [task]);

  const onValuesChange = useCallback(() => {
    setIsFocused(true);
  }, []);
  return (
    <>
      {task && (
        <div className={styles.container}>
          <div className={styles.title}>
            <BlockTitle title={t('BiddingTool.question')} icon={TASK_EDITOR_ICON_MAPPER['question']} />
          </div>
          <Form form={form} layout={'vertical'} initialValues={initialValues} className={styles.unitContent}>
            <div className={styles.inner}>
              <Form.Item name={fieldName} className={classNames(styles.textarea, { [styles.isFocused]: isFocused })}>
                <TextArea
                  autoSize={{ minRows: 2 }}
                  placeholder={t('BiddingTool.placeholderFreeText')}
                  onFocus={onValuesChange}
                />
              </Form.Item>
              <Form.Item className={classNames(styles.buttonsContainer, { [styles.isFocused]: isFocused })}>
                <Button type={'text'} onClick={onCancel}>
                  {t('Common.cancel')}
                </Button>
                <Button type={'primary'} onClick={onSave}>
                  {t('Common.save')}
                </Button>
              </Form.Item>
            </div>
          </Form>
          {!!task.filePath && (
            <TenderFile
              pdfHighlights={task.highlights}
              procurementId={task.originId}
              targetPath={task.filePath}
              eventSource="Question - Task Page"
            />
          )}
        </div>
      )}
    </>
  );
};

export default BidTaskContent;
